import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import { languageHelper } from "../../../../config/helperFunctions";

function DetailedPurchaseReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Ingredient(Code)",
      accessorKey: "code",
    },

    {
      header: "Unit Price",
      accessorKey: "price",
    },
    {
      header: "Quantity/Amount",
      accessorKey: "qty",
    },
    {
      header: "Value(Qty)",
      accessorKey: "Value(Qty)",
      cell: (row) =>
        `${row.row.original?.unit}(${row.row.original?.unit_value})`,
    },
    {
      header: "Amount",
      cell: (row) =>
        (row.row.original?.total - row.row.original?.total_vat_price)?.toFixed(
          2
        ),
    },
    {
      header: "Vat Percentage",
      accessorKey: "vat_percentage",
      cell: (row) => row.getValue() + "%",
    },
    {
      header: "Tax method",
      accessorKey: "tax_method",
      cell: (row) =>
        row.getValue() === "inclusive"
          ? languageHelper("Inclusive")
          : languageHelper("Exclusive"),
    },
    {
      header: "Vat",
      accessorKey: "total_vat_price",
      cell: (row) => row.getValue().toFixed(2),
    },
    {
      header: "Total",
      accessorKey: "total",
    },
  ];
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/detailed-purchase-report`, {
        params: {
          outletId: user?.user.outlet_id,
          start_date: startDate,
          end_date: endDate,
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the detailed purchase report!",
          error
        );
      });
  }, [endDate, startDate, user?.user.outlet_id]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Detailed Purchase Report"}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </main>
  );
}

export default DetailedPurchaseReport;
